import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  ModalHeader,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const Operator = () => {
  const [modal_list, setmodal_list] = useState(false);
  const [editUser, setEditUser] = useState(null);
  function tog_list() {
    setmodal_list(!modal_list);
  }

const [operators, setOperators] = useState([]);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    role: "",
    company_name: "",
    machine_name: "",
    password: "",
  });

  useEffect(() => {
    if (editUser) {
      setFormData({
        first_name: editUser.first_name,
        last_name: editUser.last_name,
        email: editUser.email,
        phone: editUser.phone,
        role: editUser.role,
        company_name: editUser.company_name,
        machine_name: editUser.machine_name,
        password: editUser.password,
      });
    } else {
      setFormData({
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        role: "",
        company_name: "",
        machine_name: "",
        password: "",
      });
    }
  }, [editUser]);

  // console.log(formData);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  // console.log(formData);
const authToken=localStorage.getItem("access");
 // const authToken = JSON.parse(localStorage.getItem("authUser")).token;



  const [userData, setUserData] = useState([]);

 

  useEffect(() => {
   fetchOperator();
  }, []);

 
 

  const fetchOperator = async () => {
    try {
      const response = await fetch(
        "https://api.hanoch.in/users/operators",
      );
      if (response.ok) {
        const data = await response.json();
        console.log("dattaaa",data)
        setOperators(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const [searchTerm, setSearchTerm] = useState("");
  const handleSearchTermChange = (e) => {
    setSearchTerm(e.target.value);
  };
  const filteredUsers = userData.filter(
    (user) =>
      user.first_name?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      user.last_name?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      user.email?.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  const handleInputChangeWrapper = (e) => {
    // Call the original handleInputChange function
    handleInputChange(e);

  };

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Calculate the total number of pages
  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

  // Calculate the index of the first and last item of the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // Get the items for the current page
  const currentItems = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);
  console.log("curentItems",currentItems);
  // console.log(userData);

  // Handle Previous button click
  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Handle Next button click
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Operator" />

          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
               
                </CardHeader>

                <CardBody>
                  <div id="customerList">
                    <Row className="g-4 mb-3">
                      <Col className="col-sm-auto">
                       
                      </Col>
                      <Col className="col-sm">
                        <div className="d-flex justify-content-sm-end">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control search"
                              placeholder="Search..."
                              value={searchTerm}
                              onChange={handleSearchTermChange}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <div className="table-responsive table-card mt-3 mb-1">
                      <table
                        className="table align-middle table-nowrap"
                        id="customerTable"
                      >
                        <thead className="table-light">
                          <tr>
                            <th className="sort" data-sort="customer_name">
                              User
                            </th>
                            <th className="sort" data-sort="email">
                              Email
                            </th>
                            <th className="sort" data-sort="phone">
                              Phone
                            </th>
                            <th className="sort" data-sort="phone">
                              Role
                            </th>
                            <th className="sort" data-sort="phone">
                              Company Name
                            </th>
                            <th className="sort" data-sort="phone">
                              Machine Name
                            </th>
                            <th className="sort" data-sort="date">
                              Joining Date
                            </th>
                            <th className="sort" data-sort="action">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody className="list form-check-all">
                          {currentItems === undefined ? (
                            <tr>
                              <td colSpan="8" className="text-center">
                                Loading...
                              </td>
                            </tr>
                          ) : currentItems.length === 0 ? (
                            <tr>
                              <td colSpan="8" className="text-center">
                                No content found
                              </td>
                            </tr>
                          ) : (
                            currentItems.map((user, index) => (
                              <tr key={index}>
                                <td className="customer_name">
                                  {user.first_name} {user.last_name}
                                </td>
                                <td className="email">{user.email}</td>
                                <td className="phone">{user.phone}</td>
                                <td className="">{user.role}</td>

                                <td>
                                 
                                </td>
                                <td>
                                 
                                </td>

                                <td className="date">
                                  {user.date}
                                  {/* {user.created_at.split("T")[0]} */}
                                </td>
                                <td>
                                  <div className="d-flex gap-2">
                                    <div className="edit">
                                      <button
                                        className="btn btn-warning"
                                        onClick={() => {
                                          setEditUser(user);
                                          setmodal_list(true);
                                        }}
                                      >
                                        Edit
                                      </button>
                                    </div>
                                   
                                  </div>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                      <div className="noresult" style={{ display: "none" }}>
                        <div className="text-center">
                          <lord-icon
                            src="https://cdn.lordicon.com/msoeawqm.json"
                            trigger="loop"
                            colors="primary:#121331,secondary:#08a88a"
                            style={{ width: "75px", height: "75px" }}
                          ></lord-icon>
                          <h5 className="mt-2">Sorry! No Result Found</h5>
                          <p className="text-muted mb-0">
                            We've searched more than 150+ Orders We did not find
                            any orders for you search.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="pagination-wrap hstack gap-2">
                        <Link
                          className={`page-item pagination-prev ${
                            currentPage === 1 ? "disabled" : ""
                          }`}
                          to="#"
                          onClick={handlePrevious}
                        >
                          Previous
                        </Link>
                        <ul className="pagination listjs-pagination mb-0">
                          <li>
                            Page {currentPage} of {totalPages}
                          </li>
                        </ul>
                        <Link
                          className={`page-item pagination-next ${
                            currentPage === totalPages ? "disabled" : ""
                          }`}
                          to="#"
                          onClick={handleNext}
                        >
                          Next
                        </Link>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Add Modal */}
     
      
    </React.Fragment>
  );
};

export default Operator;
